import React from 'react'
import moment from 'moment'
import translate from 'core/translate'
import styles from './catalog__template_uploadLogTasks.jcss'
import { ItemData } from '../../../../core/models/Template'
import ProgressIndicator from 'blocks.simple/progressIndicator/progressIndicator'
import { api } from 'core/api/ConnectionManager'
import { colors } from 'theme'

const StatusIndicator = ({ isIcon, status, progress }: { isIcon: boolean; status: string; progress: number }) => {
    if (isIcon) {
        return <ProgressIndicator progress={progress} max={100} done={progress === 100 || status !== 'idle'} />
    } else {
        return <div>{`${translate('serverUploading')}: ${progress}%`}</div>
    }
}

const CanceledIcon = () => {
    return (
        <div
            style={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                backgroundColor: colors.warningAccent,
            }}
        />
    )
}

const DeletedIcon = () => {
    return (
        <div
            style={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                backgroundColor: colors.error,
            }}
        />
    )
}

export default {
    getMethod: 'getUploadLogTasks',
    emptySearchText: () => translate('notFound'),
    emptyFolderText: () => translate('noTasks'),
    emptyIcon: 'not_allow',
    settingsPrefixes: 'uploadLogTasks',
    listWrapperClassName: styles.list,
    fields: () => [
        { id: 'status', name: translate('status') },
        { id: 'digitalSignageName', name: translate('name') },
        { id: 'startDate', name: translate('startDate') },
        { id: 'endDate', name: translate('endDate') },
        { id: 'autoDeleteDate', name: translate('autoDeleteDate') },
        { id: 'progress', name: translate('progress') },
        { id: 'logType', name: translate('logType') },
    ],
    getItemModel: (dataItem: ItemData, getSelected: (item: ItemData) => boolean) => {
        const item = { ...dataItem }

        if (!item.__view) {
            item.__view = {
                selected: getSelected(item),
            }
        }

        return item
    },
    isEqual: (firstItem: ItemData, secondItem: ItemData) => firstItem.id === secondItem.id,
    onUpdateListeners: [],
    onDeleteListeners: [],

    onCreateListeners: [(cb: any, clearList: string[]) => api.addObserver('uploadLogTasksCreated', cb, clearList)],
    onMultipleUpdateListeners: [
        (callback: (items: any[]) => void, clearList: string[]) => {
            api.addObserver(
                'uploadLogTasksUpdated',
                (response: number[]) => {
                    callback(response)
                },
                clearList
            )
        },
    ],
    onMultipleDeleteListeners: [
        (callback: (items: number[]) => void, clearList: string[]) => {
            api.addObserver(
                'uploadLogTasksDeleted',
                (response: number[]) => {
                    callback(response)
                },
                clearList
            )
        },
    ],
    isFolder: () => {},
    init(callback: any) {
        //@ts-ignore
        this.setState({ isInit: true, fields: this.template.fields() }, callback)
    },
    tableWrapper: styles.tableWrapper,
    list: {
        digitalSignageName: ({ digitalSignage }: { digitalSignage: { name: string } }) => digitalSignage.name,
        startDate: ({ startDate }: { startDate: string }) => moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
        endDate: ({ endDate }: { endDate: string }) => (endDate ? moment(endDate).format('YYYY-MM-DD HH:mm:ss') : '-'),
        autoDeleteDate: ({ autoDeleteDate }: { autoDeleteDate: string }) =>
            autoDeleteDate ? moment(autoDeleteDate).format('YYYY-MM-DD HH:mm:ss') : '-',
        status: (p_: { id: number; digitalSignageId: number; status: string; progress: number }) => {
            switch (p_.status) {
                case 'idle':
                case 'done':
                    return <StatusIndicator isIcon={true} status={p_.status} progress={p_.progress} />
                case 'canceled':
                    return <CanceledIcon />
                case 'deleted':
                    return <DeletedIcon />
                default:
                    return <></>
            }
        },
        progress: ({ status, progress }: { status: string; id: number; progress: number }) => {
            switch (status) {
                case 'idle':
                    return <StatusIndicator isIcon={false} status={status} progress={progress} />
                case 'done':
                    return `${translate('uploadLogDone')}`
                case 'canceled':
                    return `${translate('canceled')}`
                case 'deleted':
                    return `${translate('deleted')}`
                default:
                    return `${translate('unknown')}`
            }
        },
        logType: ({ type }: { type: 'actual' | 'full' }) => {
            return type === 'actual' ? translate('actual_logs') : translate('full_logs')
        },
    },
}
